import { render, staticRenderFns } from "./featured-offer.vue?vue&type=template&id=1f2d50ba&scoped=true&"
import script from "./featured-offer.vue?vue&type=script&lang=js&"
export * from "./featured-offer.vue?vue&type=script&lang=js&"
import style0 from "./featured-offer.vue?vue&type=style&index=0&id=1f2d50ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2d50ba",
  null
  
)

export default component.exports